/* --- NAV TEXT --- */

export const BCC_NAV_LABEL_HOME = 42722; // `Home`;
export const BCC_NAV_LABEL_ADMIN = 42723; // `Admin`;
export const BCC_NAV_LABEL_USERS = 42724; // `Users`;
export const BCC_NAV_LABEL_DIRECTORIES = 42725; // `Directories`;
export const BCC_NAV_LABEL_GROUPS = 42726; // `Groups`;
export const BCC_NAV_LABEL_OPTIONS = 42730; // `Options`;
export const BCC_NAV_LABEL_AUDIT_LOG = 42731; // `Audit Log`;
export const BCC_NAV_LABEL_ESSENTIALS = 42732; // `Essentials`;
export const BCC_NAV_LABEL_PARTNER = 42734; // `Partner`;
export const BCC_NAV_LABEL_CUSTOMER_ACCOUNTS = 42735; // `Customer Accounts`;
export const BCC_NAV_LABEL_APPLIANCE_CONTROL_MANAGEMENT = 42736; // `Appliance Control Management`;
export const BCC_NAV_LABEL_SAML_METADATA = 46381; // `SAML`;
